<template>
  <main>
    <slot />
  </main>
</template>

<script>
export default {
  name: 'AppLayoutDefault'
}
</script>
